import { render, staticRenderFns } from "./DirForm.vue?vue&type=template&id=216beb11&scoped=true&"
import script from "./DirForm.vue?vue&type=script&lang=js&"
export * from "./DirForm.vue?vue&type=script&lang=js&"
import style0 from "./DirForm.vue?vue&type=style&index=0&id=216beb11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216beb11",
  null
  
)

export default component.exports